// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"efacce16","453":"ce89852e","732":"1f8287b8","977":"b46c8f9b"}[chunkId] + ".chunk.js";
};